import { getMenuSteps } from '@tecsinapse-org/portal-menu-kit'
import { useEffect } from 'react'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { homeTour } from '../components/home-tour'

export const useHomeOnboarding = ({ itensMenu }) => {
  const { currentUserOnboardingIsSeen, setSteps, setOpen, loading, save } =
    useOnboarding(Onboardings.HOME)

  useEffect(() => {
    if (!currentUserOnboardingIsSeen && !loading) {
      setSteps([...homeTour(itensMenu), ...getMenuSteps(undefined, save)])
      setOpen()
    }
  }, [currentUserOnboardingIsSeen, itensMenu, setOpen, setSteps, loading, save])
}
